// src/Pages/Photography.jsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Link as RouterLink } from "react-router-dom";
import { ThemeProvider, createTheme, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Footer from "./Footer";

export default function Photography() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: {
        fontSize: "3rem",
        fontWeight: 200,
        wordBreak: "break-word",
        overflowWrap: "anywhere",
      },
      body1: {
        fontSize: "2.2rem",
        fontWeight: 200,
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        [base.breakpoints.down("sm")]: {
          fontSize: "1.6rem",
          fontWeight: 300,
        },
      },
    },
  });

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const linkGridStyle = {
    textDecoration: "none",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    alignItems: "start",
    columnGap: "0.25rem",
    color: "black",
  };

  const linkGridStyleMuted = {
    ...linkGridStyle,
    color: "#808080",
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="start"
        height="88vh"
        marginTop="5vh"
        marginBottom="10vh"
        maxWidth="100vw"
      >
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="flex-start"
          maxWidth="100vw"
        >
          {/* Title */}
          <Grid item xs={12} sx={{ mb: "3vh" }}>
            <Typography
              variant="h1"
              component={RouterLink}
              to="/"
              sx={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              // photography
            </Typography>
          </Grid>

          {/* Links */}
          <Grid
            item
            sx={{
              width: isMobile ? "80vw" : "auto",
              display: "flex",
              flexDirection: "column",
              gap: 1.2,
            }}
          >
            <Typography variant="body1">
              <RouterLink to="/ph/immersion_i-iii" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>immersion I-III</span>
              </RouterLink>
            </Typography>

            <Typography variant="body1">
              <RouterLink to="/ph/bern2025" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>bern 2025</span>
              </RouterLink>
            </Typography>

            <Typography variant="body1">
              <RouterLink to="/ph/untitledbodyproject" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>"untitled body project"</span>
              </RouterLink>
            </Typography>

            <Typography variant="body1">
              <a
                href="https://www.leonidpesenti.com/portfolio2024.pdf"
                target="_blank"
                rel="noreferrer"
                style={linkGridStyle}
              >
                <span aria-hidden="true">//&nbsp;</span>
                <span>
                  portfolio 2024{" "}
                  <span style={{ fontSize: "0.6em" }}>(.pdf)</span>
                </span>
              </a>
            </Typography>

            <Typography variant="body1">
              <a
                href="/pesenti_leonid_manuel_technique_2024.pdf"
                target="_blank"
                rel="noreferrer"
                style={linkGridStyle}
              >
                <span aria-hidden="true">//&nbsp;</span>
                <span>
                  "manuel technique"{" "}
                  <span style={{ fontSize: "0.6em" }}>(.pdf)</span>
                </span>
              </a>
            </Typography>

            <Typography variant="body1">
              <RouterLink to="/ph/capitals2023" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>capitals 2023</span>
              </RouterLink>
            </Typography>


            <Typography variant="body1">
              <RouterLink to="/ph/ukraine2022" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>ukraine 2022</span>
              </RouterLink>
            </Typography>

            <Typography variant="body1">
              <RouterLink to="/ph/pahf" style={linkGridStyle}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>"post-apocalyptic high fashion"</span>
              </RouterLink>
            </Typography>

            <Typography variant="body1">
              <RouterLink to="/ph/prints" style={linkGridStyleMuted}>
                <span aria-hidden="true">//&nbsp;</span>
                <span>prints for sale</span>
              </RouterLink>
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </ThemeProvider>
  );
}
